import { render, staticRenderFns } from "./GroupHandle.vue?vue&type=template&id=bd5111be&scoped=true"
import script from "./GroupHandle.vue?vue&type=script&lang=ts"
export * from "./GroupHandle.vue?vue&type=script&lang=ts"
import style0 from "./GroupHandle.vue?vue&type=style&index=0&id=bd5111be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5111be",
  null
  
)

export default component.exports